import React, { useState } from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import { uri } from '../../../../../help/Api';
import toast, { Toaster } from 'react-hot-toast';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import ItemsCompsForm from './ItemsCompsForm';
import ItemsCompsTable from './ItemsCompsTable';
import { colors, Typography } from '@material-ui/core';
import axios from 'axios';
import { useStylesSunComp } from '../../subUnits/SubUnits';


const defaultData = {
    item_id: 0,
    mat_id: 0,
    itemName: '',
    item: {},
    mat_unit: 0,
    unitName: '',
    perc: 1,
    mat_quan: 0,
    mat_quantot: 0,
    price: '',
    no: 0,
    editUnit: false,
    editquan: false,
    defUnit: {},
    units: [],
    item: {}
}

export default function ItemsComps(props) {

    const {   items, setItems,khamsItems, itemsComms, setItemsComms,setConfirmDialog} = props;

    const { t } = useTranslation();
    const classes = useStylesSunComp();
    const [newItemComp, seNewItemComp] = useState(defaultData);

    const onChangeData = (prop) => (event) => {
        let i = {
            mat_quan: Number(event.target.value),
            perc: Number(newItemComp.perc),
        };
        let totQuan = parseFloat(i.mat_quan * i.perc).toFixed(2);
        seNewItemComp({...newItemComp, [prop]: event.target.value, mat_quantot: totQuan })
    }
    const onChangeAutoData = async (prop, newValue) => {
        if (prop === "unit") {
            let i = {
                mat_quan: Number(newItemComp.mat_quan),
                perc: Number(newValue.perc),
                price: Number(newValue.purch),
            };
            seNewItemComp({
                ...newItemComp,
                item_id: items.id,
                defUnit: newValue,
                mat_unit: newValue.unit,
                unitName: newValue.unitName,
                perc: i.perc,
                price: i.price,
                mat_quantot: parseFloat(i.mat_quan * i.perc).toFixed(2),
            });
        } else {
            seNewItemComp({ ...newItemComp, units: [], defUnit: {}, perc: 0 });
            await axios
                .get(
                    uri +
                    `RptSafes/itemUnitOnly?curr_id=${newValue.id}`
                )
                .then((res) => {
                    let i = {
                        mat_quan: Number(newItemComp.mat_quan),
                        perc: Number(res.data?.subUnits[0].perc),
                        price: Number(res.data?.subUnits[0].purch),
                    };
                    seNewItemComp({
                        ...newItemComp,
                        item_id: items.id,
                        item: newValue,
                        itemName: newValue.symbol,
                        mat_id: newValue.id,
                        perc: i.perc,
                        price: i.price,
                        mat_quantot: parseFloat(i.mat_quan * i.perc).toFixed(2),
                        unitName:res.data?.subUnits[0].unitName,
                        mat_unit:res.data?.subUnits[0].unit,
                        units: res.data?.subUnits ?? [],
                        defUnit: res.data?.subUnits[0] ?? {},
                    });
                })
                .catch((err) => {
                    seNewItemComp({ ...newItemComp, units: [] });
                });
        }

    };


    const onSubmit = (e) => {
        e.preventDefault();
        var oldData1 = itemsComms.filter((obj) => obj.mat_id == newItemComp.mat_id);
        let newData = {
            ...newItemComp,
            item_id: items.id,
            price: Number(newItemComp.price),
            mat_quan: Number(newItemComp.mat_quan),
            perc: Number(newItemComp.perc),
            no: itemsComms.length,
            editUnit: false,
            editquan: false,
            defUnit: {},
        };
        if (oldData1.mat_id > 0) {
            alert("الصنف موجود من قبل ");
        } else {
            if (parseFloat(newItemComp.mat_quan) == 0 || parseFloat(newItemComp.mat_id)<1 ) {
                alert("برجاء اكمال البيانات");
            } else {
                let newDatas = [...itemsComms, newData];
                setItemsComms(newDatas);
                seNewItemComp(defaultData);
                let purch = newDatas?.reduce((a, v) => (a = a + parseFloat(v.price * v.mat_quan)), 0).toFixed(2);
                setItems({ ...items, purch_price: purch });
            }
        }
    }

    return (
        <Grid className={classes.root} container>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
                    color="primary"
                >
                    {"المواد الخام"}
                </Typography>
            </Grid>
            <Toaster />
            <ItemsCompsForm
                {...{
                    newItemComp,
                    khamsItems,
                    onSubmit,
                    onChangeData,
                    onChangeAutoData,
                }}
            />
            <ItemsCompsTable
                {...{
                    itemsComms, setItemsComms, setConfirmDialog, items,setItems 
                }}
            />

        </Grid>
    )

}